import { ComponentProps } from "react";

import Heading from "components/heading";
import HeroSection from "components/hero-section";

import { faqData } from "./data";

const QuestionHeading = (props: ComponentProps<typeof Heading>) => (
  <Heading tag="h3" size="h5" className="mb-4" {...props} />
);

export default function FAQSections() {
  return (
    <>
      {faqData.map(section => (
        <div className="odd:bg-gray-100" key={section.id}>
          <HeroSection title={section.title} id={section.id}>
            <HeroSection.Content className="text-left">
              <HeroSection.Header className="items-start justify-start md:items-start mt-0 mb-10 md:mb-14">
                <Heading tag="h2">{section.title}</Heading>
              </HeroSection.Header>

              <div className="space-y-10 md:space-y-14">
                {section.faqs.map((item, index) => (
                  <div key={`${item.question}_${index}`}>
                    <QuestionHeading>{item.question}</QuestionHeading>
                    {item.answer}
                  </div>
                ))}
              </div>
            </HeroSection.Content>
          </HeroSection>
        </div>
      ))}
    </>
  );
}
